/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';

import { Multitenant } from '../../../services/multitenant.provider';
import { AuthProvider } from '../../../services/auth.provider';

import { PopUp } from '../../../models/popup.model';
import { UIUPopUpNoShow } from '../../utils';

@Injectable({ providedIn: 'root' })
export class PopUpService {
  private popup: PopUp = new PopUp();
  private showUIPopUp = false;

  constructor(private multiTenant: Multitenant, private auth: AuthProvider) {}

  get UIPopUp() {
    return this.showUIPopUp;
  }
  set UIPopUp(value) {
    this.showUIPopUp = value;
  }

  havePassedSevenDays() {
    if(UIUPopUpNoShow.includes(document.location.pathname)) {
      return false;
    }

    const now = Date.now();
    const then = new Date(Number(localStorage.getItem('uit')) * 1000);
    const thenPlus7 = then.setDate(then.getDate() + 7);
    return now > thenPlus7;
  }
}
